<template>
    <span :class="{ 'error--text': error }">{{ rep }}</span>
</template>


<script setup>
/**
 * import DateColumn from from '@datatable/columns/Date'
 * 
 *     <template v-slot:item.date="{ item }">
 *       <DateColumn  v-model="item.date"></DateColumn>
 * or
 *       <DateColumn :value="item.date" warn-past></DateColumn>
 *     </template>
 * 
 */

    import { date } from "@lib/date";
    import {computed, ref} from 'vue'

    const props = defineProps({
        value: {
            type: [String, Date]
        },
        warnPast: {
            type: Boolean,
        },
        dow: {
            type: Boolean,
        },
        // short works only with dow. 
        short: {
            type: Boolean,
        },
    })
    const error = computed({
        get() {
            if (!props.warnPast) {
                return false;
            }
            if (date.isInPast(props.value)) {
                return true;
            }
            return false;
        },
    })
    const rep = computed({
        get() {
            if (!props.value) {
                return "";
            }
            if (props.dow) {
                return date.fmt.dow(props.value, props.short);
            }
            return date.fmt.local(props.value);
        },
    })

</script>

